.article-page {
  --content-max: 900px;
  --container-pad: clamp(16px, 4vw, 48px);
  --tap-min: 44px;

  .page {
    width: 100%;
    min-height: 100%;
    background-color: rgba(255, 255, 255, 1);
  }

  .article-header {
    width: 100%;
  }

  .article-main {
    width: min(var(--content-max), calc(100% - 2 * var(--container-pad)));
    margin: 0 auto;
    padding: clamp(24px, 6vw, 72px) 0 clamp(64px, 10vw, 140px);
  }

  .article-back {
    display: inline-flex;
    align-items: center;
    min-height: var(--tap-min);
    color: rgba(163, 135, 95, 1);
    font-size: clamp(14px, 1.1vw, 16px);
    font-family: Red Rose-Medium;
    font-weight: normal;
    text-decoration: none;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  .article-eyebrow {
    margin: clamp(20px, 3vw, 32px) 0 0;
    color: rgba(163, 135, 95, 1);
    font-size: clamp(14px, 1.2vw, 18px);
    font-family: Red Rose-Medium;
    font-weight: normal;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .article-title {
    margin: clamp(10px, 1.6vw, 18px) 0 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(32px, 4.4vw, 56px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    line-height: 1.1;
    white-space: normal;
  }

  .article-intro {
    margin: clamp(18px, 3vw, 32px) 0 0;
    max-width: 72ch;
    color: rgba(124, 124, 124, 1);
    font-size: clamp(16px, 1.4vw, 20px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    line-height: 1.7;
  }

  .article-section {
    margin: clamp(40px, 6vw, 72px) 0 0;
    padding-top: clamp(32px, 5vw, 56px);
    border-top: 1px solid rgba(22, 0, 4, 0.1);
  }

  .article-section__eyebrow {
    margin: 0 0 0.75rem;
    color: rgba(163, 135, 95, 1);
    font-size: 0.75rem;
    font-family: Red Rose-Medium;
    font-weight: normal;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  .article-section__title {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(22px, 2vw, 30px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    line-height: 1.2;
  }

  .article-section__subtitle {
    margin: 2rem 0 0.75rem;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(18px, 1.5vw, 22px);
    font-family: Red Rose-Medium;
    font-weight: normal;
    line-height: 1.35;
  }

  .article-section__text {
    margin: clamp(12px, 1.6vw, 18px) 0 0;
    color: rgba(124, 124, 124, 1);
    font-size: clamp(15px, 1.1vw, 18px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    line-height: 1.7;
  }

  .article-list {
    margin: 1rem 0 1.75rem;
    padding-left: 1.25rem;
    color: rgba(124, 124, 124, 1);
    font-size: clamp(15px, 1.1vw, 18px);
    font-family: Red Rose-Regular;

    li {
      margin-bottom: 0.65rem;
      line-height: 1.7;
    }
  }

  .article-feature-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.5rem;
    margin: 2rem 0;
  }

  .article-feature {
    padding: 1.5rem;
    border: 1px solid rgba(22, 0, 4, 0.12);
  }

  .article-feature__title {
    margin: 0 0 0.75rem;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(17px, 1.3vw, 20px);
    font-family: Red Rose-Medium;
    font-weight: normal;
    line-height: 1.35;
  }

  .article-feature__text {
    margin: 0;
    color: rgba(124, 124, 124, 1);
    font-size: clamp(15px, 1.1vw, 18px);
    font-family: Red Rose-Regular;
    line-height: 1.7;
  }

  @media (max-width: 768px) {
    .article-feature-list {
      grid-template-columns: 1fr;
    }

    .article-feature {
      padding: 1.25rem;
    }
  }
}
